import { state } from './state';

export const gettersLocaly = {
	getYears: () => state.years
};
